import { Component, input, OnInit, output, signal } from '@angular/core';
import { Building } from 'app/classes/building';
import { CollectionAsset } from 'app/classes/collection-for-assets';
import { Gateway } from 'app/classes/gateway';
import { Insight } from 'app/classes/insight';
import { APIService } from 'app/shared/api.service';
import { InsightsService } from 'app/shared/insights.service';
import { IGrandTotals } from './aq-report-type/aq-report-type.component';

@Component({
  selector: 'app-aq-collections-report',
  templateUrl: './aq-collections-report.component.html',
  styleUrl: './aq-collections-report.component.css',
  standalone: false
})
export class AqCollectionsReportComponent implements OnInit {
  FOURD_LOGO = '4d-logo.png';
  startDate = input.required<Date>()
  building = input.required<Building>();
  collections = input.required<CollectionAsset[]>();
  useOrgLogo = input<boolean>(false);

  onReportGenerated = output<Insight>();

  logo = signal<string>('4d-logo.png');

  insight: Insight = new Insight();
  headerTitle: string;
  isReady = false;
  hasData = false;
  isLight: boolean;
  svgLocation = 'assets/svg/';
  grandTotals: IGrandTotals;

  constructor(private apiService: APIService, private insightsService: InsightsService) {

  }

  ngOnInit(): void {
    this.insight.setAlarmsFromBuilding(this.building());
    this.getInsights();

    if (this.useOrgLogo()) {
      const userOrg = this.apiService.getUserOrg();
      this.setLogo(userOrg.settings.theme_logo);
    } else {
      this.setLogo(this.FOURD_LOGO);
    }
  }

  setLogo(logoKey: string) {
    if (logoKey.indexOf('/') !== -1) {
      // a path was passed.
      this.logo.set(logoKey);
    } else {
      this.logo.set(`https://4d-org-logos.s3.eu-west-2.amazonaws.com/${logoKey}`);
    }
  }

  getInsights() {
    setTimeout(() => {
      window.scrollTo({ top: 1200, behavior: 'smooth' });
    }, 100);

    this.insightsService.getAQInsights(this.building().id, this.collections().map(c => c.id), this.startDate()).then(response => {

      const { collection, grandTotals, kvStore } = response;

      if (!collection || !grandTotals) {
        this.isReady = true;
        this.hasData = false;
        this.onReportGenerated.emit(this.insight);
        return;
      }

      this.grandTotals = grandTotals;

      if (kvStore?.insightaq_hse_co2) {
        // Org overrides the WHO defaults
        // Hard coded for now, this may never change.
        this.insight.types = { ...this.insight.types, ...kvStore.insightaq_hse_co2 }
      }

      console.log(this.insight.types.co2)

      this.insight.generatedAt = this.startDate();
      this.insight.configuration = { start: this.startDate(), end: null, assets: null, title: 'AQ Collections Report', types: null, ranges: null };
      this.insight.setGrandGrandTotals(grandTotals);
      this.insight.setTelemetry(collection);

      // this.insight.gateways = this.collections().map(c => new Gateway({ id: c.id, title: c.title, assets: c.assets }));

      this.insight.collectionAssets = this.collections();

      this.headerTitle = this.insight.configuration?.title.split(' from ')[0] || 'AQ Collections Report';

      this.isReady = true;
      this.hasData = true;

      setTimeout(() => {
        const id = 'report';
        const yOffset = -410;
        const element = document.getElementById(id);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 10);
      this.onReportGenerated.emit(this.insight);
    });
  }
}
